import "../styles/Login.scss";
import React, { useEffect, useState } from "react";
import { auth, db } from "@/utils/firebase";
import {
  sendEmailVerification,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import Logo from "../assets/logo.svg";
import Spinner from "@/components/Spinner";
import { Input } from "@Components/input";
import { Label } from "@/components/ui/label";
import { Button } from "@Components/button";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { getUser } from "@/hooks/useLocalStorage";

function Signup() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleRoles = (val) => {
    const roleMap = {
      buyer: ["buyer"],
      seller: ["seller"],
      both: ["buyer", "seller"],
    };

    setRoles(roleMap[val] || []);
  };

  const signUp = async () => {
    setLoading(true);
    try {
      // Auth
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );
      const user = userCredential.user;

      // Verify email
      await sendEmailVerification(user);
      localStorage.setItem("lastEmailSent", Date.now());
      console.log("Verification email sent to:", user.email);

      // User account
      const userRef = doc(db, "users", user.uid);
      const userData = {
        user_id: user.uid,
        email: user.email,
        roles: roles,
        created_at: serverTimestamp(),
      };

      await setDoc(userRef, userData, { merge: true });
      console.log("User successfully created");
    } catch (error) {
      // Handle error codes
      if (error.code === "auth/weak-password") {
        setError("Password is too weak. Please choose a stronger password.");
      } else if (error.code === "auth/email-already-in-use") {
        setError("Email address already in use.");
      } else {
        setError("An error occurred during registration.");
      }
      console.error("Error registering user:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = getUser();
    if (user) {
      navigate("/home");
    }
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="loginWrapper">
      <div className="loginLeft">
        <form onSubmit={signUp} className="w-[70%] mobileLoginWrapper">
          <img src={Logo} alt="iSettle" className="logo" />

          <p className="my-4 text-sm text-muted">
            Please fill in your details to sign up
          </p>

          <div className="grid w-full max-w-sm items-center gap-1.5">
            <Label htmlFor="role" className="text-muted">
              Sign up as
            </Label>

            <Select onValueChange={(val) => handleRoles(val)}>
              <SelectTrigger className="w-full h-[50px] mb-3 text-muted">
                <SelectValue placeholder="Select role" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="buyer">Buyer</SelectItem>
                <SelectItem value="seller">Seller</SelectItem>
                <SelectItem value="both">Both Buyer & Seller</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="grid w-full max-w-sm items-center gap-1.5">
            <Label htmlFor="email" className="text-muted">
              Email
            </Label>

            <Input
              type="text"
              value={email}
              placeholder="Enter email"
              className="w-full h-[50px] mb-3"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="grid w-full max-w-sm items-center gap-1.5">
            <Label htmlFor="email" className="text-muted">
              Password
            </Label>

            <Input
              type="password"
              value={password}
              placeholder="Enter password"
              className="w-full h-[50px] mb-3"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <p className="my-4 text-sm" style={{ color: "red" }}>
              {error}
            </p>
          )}

          <Button
            type="submit"
            variant="outline"
            disabled={!email || !password || !roles}
            className="w-full max-w-sm h-[50px] text-white mt-1.5 bg-green"
          >
            Sign Up
          </Button>

          <p className="mt-4 text-sm">
            Already have an account?{" "}
            <span
              onClick={() => navigate("/login")}
              className="text-green cursor-pointer"
            >
              Sign in
            </span>
          </p>
        </form>
      </div>

      <div className="loginRight">
        <div className="contentBox">
          <h3 className="text-white text-3xl font-bold">
            Your Premier Destination for Scrap Plastic Trading
          </h3>
          <p className="mt-2 text-white text-lg">
            Where plastic trading meets simplicity. Join us in shaping a
            sustainable future.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;
